import { isObject } from 'utils/guards';
import { logger } from 'utils/logger';
import { SettingsServiceTypes as Types } from '../../types';

export const settingsServiceParser = {
  /**
   * Parses the settings state string into a state model
   * @param payload - is the stringified state model
   */
  parse(payload: string): Types.StateModel {
    let parsedOutput: Record<string, unknown>;
    try {
      parsedOutput = JSON.parse(payload);
    } catch (e) {
      parsedOutput = {};
    }

    if (!isObject(parsedOutput)) {
      logger.warn(`Invalid settings string: "${payload}"`);
      return {} as Types.StateModel;
    }

    return Object.entries(parsedOutput).reduce((acc, [key, value]) => {
      if (this.isValidKey(key)) {
        return { ...acc, [key]: this.getValidGroup(value) };
      }
      return acc;
    }, {} as Types.StateModel);
  },
  stringify(items: Types.StateModel): string {
    return JSON.stringify(items);
  },
  isValidKey(key: string | number | symbol): key is string {
    return typeof key === 'string';
  },
  getValidGroup(group: unknown): Types.GroupModel {
    if (
      isObject(group) &&
      this.isValidKey((group as Types.GroupModel).name) &&
      isObject((group as Types.GroupModel).items)
    ) {
      return group as Types.GroupModel;
    }
    return {} as Types.GroupModel;
  }
};
